import '../styles.css';
import { mountLearnPage } from '../ui/learn/page.js';
import { REMOVAL_PAGE } from './removal.js';

mountLearnPage(REMOVAL_PAGE);
